// extracted by mini-css-extract-plugin
module.exports = {"mainAdornment":"style_main-adornment__Jf9j4","description":"style_description__RUcMa"};